import { MarkerType } from '@xyflow/react';
import * as edges from '../kit';
import { ERFEdge } from '../enums';
import { DARK_GREY_HEX, RECYCLE_HEX, L_FLOW_HEX } from './rf.constant';
export const RF_EDGE_TYPES = {
    [ERFEdge.Default]: edges.RFDefaultEdge,
    [ERFEdge.Material]: edges.RFMaterialEdge,
    [ERFEdge.Energy]: edges.RFEnergyEdge,
    [ERFEdge.Logical]: edges.RFLogicalEdge,
    [ERFEdge.Recycle]: edges.RFRecycleEdge
};
export const RF_DEFAULT_EDGE_PROPS = {
    markerEnd: {
        type: MarkerType.ArrowClosed,
        color: DARK_GREY_HEX,
        height: 14,
        width: 14
    }
};
export const RF_LOGICAL_EDGE_PROPS = {
    markerEnd: {
        type: MarkerType.ArrowClosed,
        color: L_FLOW_HEX,
        height: 14,
        width: 14
    }
};
export const RF_RECYCLE_EDGE_PROPS = {
    markerEnd: {
        type: MarkerType.ArrowClosed,
        color: RECYCLE_HEX,
        height: 14,
        width: 14
    }
};
//# sourceMappingURL=rfEdge.constants.js.map